module.exports = __webpack_public_path__ + "img/1.46cac114.png";